import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7362b90e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column","color":"black","font-weight":"600"} }
const _hoisted_2 = { style: {"font-weight":"700"} }
const _hoisted_3 = { class: "requirements_container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "additional_info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_7 = {
  key: 0,
  class: "additional_info"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_11 = {
  key: 0,
  class: "additional_info"
}
const _hoisted_12 = {
  key: 1,
  class: "additional_info"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_16 = {
  key: 0,
  class: "additional_info"
}
const _hoisted_17 = {
  key: 1,
  class: "additional_info"
}
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { key: 5 }
const _hoisted_20 = { key: 6 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_22 = {
  key: 0,
  class: "additional_info"
}
const _hoisted_23 = {
  key: 1,
  class: "additional_info"
}
const _hoisted_24 = { key: 7 }
const _hoisted_25 = { key: 8 }
const _hoisted_26 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Dialog"], {
    visible: $setup.transactionContextStore.orderModalVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (($setup.transactionContextStore.orderModalVisible) = $event)),
    modal: "",
    header: $setup.i18n.t('BUY_TOKENS_VIEW.ORDER_SUMMARY'),
    baseZIndex: -100,
    style: { width: '95vw', 'max-width': '800px', 'z-index': 500}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.YOU_INVEST')) + " " + _toDisplayString($setup.transactionContextStore.amountToBuy.amount.toString()) + " C4E", 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode($setup["TooltipComponent"], {
              style: {"margin-left":"10px"},
              "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.KYC')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.PASS_KYC')) + " " + _toDisplayString($setup.transactionContextStore.getRequiredKycLevel), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["tooltip-text"]),
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, "Level " + _toDisplayString($setup.useUserServiceStore().kycLevel) + " - verified", 1 /* TEXT */),
            _createTextVNode(),
            _hoisted_6,
            (!$setup.isKycLevelRequired)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Level " + _toDisplayString($setup.transactionContextStore.getRequiredKycLevel) + " - required", 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.isKycLevelRequired)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode($setup["IconComponent"], {
                  style: {"color":"#72bf44","height":"35px","width":"35px"},
                  name: "Check"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode($setup["IconComponent"], {
                  style: {"color":"#72bf44","height":"35px","width":"35px"},
                  name: "Check"
                }),
                _createVNode($setup["Button"], {
                  onClick: $setup.onKycStart,
                  class: "p-button p-component secondary-link button-w7"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.START_KYC')) + " - level " + _toDisplayString($setup.transactionContextStore.getRequiredKycLevel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])),
          _createElementVNode("div", null, [
            _createVNode($setup["TooltipComponent"], {
              style: {"margin-left":"10px"},
              "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.TERMS')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.ACCEPT_SALE_TERMS')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["tooltip-text"]),
            _createTextVNode(),
            _hoisted_10,
            ($setup.isTermsAccepted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Accepted"))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, "Not accepted"))
          ]),
          ($setup.isTermsAccepted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode($setup["IconComponent"], {
                  style: {"color":"#72bf44","height":"35px","width":"35px"},
                  name: "Check"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode($setup["Button"], {
                  class: "p-button p-component secondary-link button-w7",
                  onClick: $setup.showApprovalModalFunc
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.ACCEPT')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])),
          _createElementVNode("div", null, [
            _createVNode($setup["TooltipComponent"], {
              style: {"margin-left":"10px"},
              "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.CLAIMER_ADDRESS'),
              text: $setup.i18n.t('BUY_TOKENS_VIEW.PROVIDE_CLAIMER_ADDRESS'),
              "tooltip-link": "https://docs.c4e.io/usersGuide/auth.html"
            }, null, 8 /* PROPS */, ["tooltip-text", "text"]),
            _createTextVNode(),
            _hoisted_15,
            ($setup.claimerAddress)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.addDotsInsideTooLongString($setup.claimerAddress, 28)), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_17, "Not provided"))
          ]),
          ($setup.claimerAddress != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode($setup["IconComponent"], {
                  style: {"color":"#72bf44","height":"35px","width":"35px"},
                  name: "Check"
                })
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode("        <div v-else-if=\"!isLoggedIn && claimerAddress == undefined\">"),
          _createCommentVNode("          <Button @click=\"emit('onConnect')\""),
          _createCommentVNode("                  class=\"p-button p-component secondary-link button-w7\">"),
          _createCommentVNode("            {{ $t('COMMON.CONNECT') }}"),
          _createCommentVNode("          </Button>"),
          _createCommentVNode("        </div>"),
          ($setup.claimerAddress==undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode($setup["Button"], {
                  onClick: $setup.provideClaimerAddress,
                  class: "p-button p-component secondary-link button-w7"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.PROVIDE_ADDRESS')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.transactionContextStore.paymentCurrency==$setup.Currency.STABLE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode($setup["TooltipComponent"], {
                  style: {"margin-left":"10px"},
                  "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.SOURCE_ADDRESS')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.PROVIDE_SOURCE_ADDRESS')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["tooltip-text"]),
                _hoisted_21,
                ($setup.sourceAddress)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString($setup.addDotsInsideTooLongString($setup.sourceAddress, 28)), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, "Not provided"))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.transactionContextStore.paymentCurrency==$setup.Currency.STABLE && $setup.sourceAddress != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode($setup["IconComponent"], {
                  style: {"color":"#72bf44","height":"35px","width":"35px"},
                  name: "Check"
                })
              ]))
            : ($setup.transactionContextStore.paymentCurrency==$setup.Currency.STABLE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode($setup["Button"], {
                    onClick: $setup.provideSourceAddress,
                    class: "p-button p-component secondary-link button-w7"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.PROVIDE_ADDRESS')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode($setup["Button"], {
            class: "p-button p-component cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.transactionContextStore.orderModalVisible=false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.CANCEL_ORDER')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode($setup["Button"], {
            class: "p-button p-component secondary",
            disabled: !$setup.canConfirmOrder,
            onClick: $setup.onConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.CONFIRM_ORDER')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "header"]))
}